import type { SurveyAnonymity, SurveyResponseMode, SurveySpaceMode } from '@/types/surveys'

export interface SurveysSpaceConfig {
  mode: SurveySpaceMode
}

export const defaultSurveysConfig = (): SurveysSpaceConfig => ({ mode: 'multi' })

/** Absent or anything else in the stored config means "several surveys". */
export const surveysConfigOf = (moduleConfig: Record<string, unknown> | null | undefined): SurveysSpaceConfig => ({
  mode: moduleConfig?.mode === 'single' ? 'single' : 'multi'
})

/** `PUT /spaces` refuses "one survey" on a space with two or more: the message goes under the choice. */
export const surveysConfigApiErrors = (err: unknown): { mode: string } | null => {
  const data = (err as { response?: { status?: number; data?: { message?: string; errors?: { param?: string; message?: string }[] } } } | null)?.response
  const hit = data?.data?.errors?.find((e) => e.param === 'moduleConfig.mode' || e.param === 'mode')
  if (!hit && data?.status !== 409) return null
  return { mode: hit?.message || data?.data?.message || '' }
}

/** The survey a one-survey space is born with: the essentials, the questions come in the editor. */
export interface SurveyDraft {
  title: string
  description: string
  /** `null` is blank. */
  template: string | null
  anonymity: SurveyAnonymity
  responseMode: SurveyResponseMode
}

export const emptySurveyDraft = (): SurveyDraft => ({ title: '', description: '', template: null, anonymity: 'IDENTIFIED', responseMode: 'optional' })
